module.exports = "https://bt2-static.vkplay.ru/promo/event/img/logo_wizardgames.2a69c0bb.svg";